import { useContext, useState } from 'react'
import { useRouter } from 'next/router'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import { GlobalStateContext } from 'context/GlobalContextProvider'
import { LIVE_SITE_URL } from '@constants'
import useClearTimeout from 'hooks/useClearTimeout'

import Link from 'components/Link'
import Title from 'components/Title'
import BackButton from 'components/BackButton'

import s from './NewsHeader.module.css'
import { useAtom } from 'jotai/index'
import { currentSiteAtom } from '../../lib/atoms'

function NewsHeader({ categorySlug = '', categories = [] }) {
  const [currentSite] = useAtom(currentSiteAtom)
  const state = useContext(GlobalStateContext)

  const router = useRouter()
  const [mobileMenu, setMobileMenu] = useState(false)
  const [shareText, setShareText] = useState('Share News')
  const [timeoutId, setTimeoutId] = useState(null)
  const pageLink = `${LIVE_SITE_URL}${router.asPath}`

  useClearTimeout(timeoutId)

  const setMobileTitle = (label) => {
    if (!label) return null
    return <h2 className={s.mobileTitle}>{label}</h2>
  }

  const handleOpenMenu = () => {
    setMobileMenu(true)
  }

  const handleCloseMenu = () => {
    setMobileMenu(false)
  }

  const handleShare = () => {
    let copyLink = document.getElementById('news-share-link')
    copyLink.select()
    document.execCommand('copy')

    setShareText('Link copied')
    const timeoutId = setTimeout(() => {
      setShareText('Share News')
    }, 1000)
    setTimeoutId(timeoutId)
  }

  return (
    <div
      className={classNames(s.container, {
        [s.mobileMenuVisible]: mobileMenu === true,
      })}
    >
      <div className={s.mobileHeader}>
        <BackButton
          className={s.backBtn}
          fallback={`${currentSite?.path}news`}
        />
        {categorySlug === ''
          ? setMobileTitle('Latest')
          : setMobileTitle(categorySlug)}
        {categories
          ?.filter(({ name }) => name === categorySlug)
          .map(({ name }) => (
            <h2 key={name} className={s.mobileTitle}>
              {name}
            </h2>
          ))}
        {/* TODO: We have used this layout in multiple places. Should try turn into component */}
        <button
          type="button"
          className={s.mobileMenuBtn}
          onClick={handleOpenMenu}
        >
          <span />
        </button>
        <div className={s.mobileMenu}>
          <div className={s.mobileMenuItem}>
            <button type="button" className={s.shareBtn} onClick={handleShare}>
              <span className={s.mobileMenuLabel}>{shareText}</span>
              <input
                id="news-share-link"
                className={s.shareLink}
                type="text"
                defaultValue={pageLink}
              />
            </button>
          </div>
        </div>
        <button
          type="button"
          className={s.closeMenuBtn}
          onClick={handleCloseMenu}
        />
      </div>
      <div className={s.header}>
        <Title
          className={s.title}
          title="Explore"
          subtitle="Our World"
          swapColour
        />
        <div className={s.links}>
          <Link
            type="Page"
            href="news"
            className={classNames(s.link, {
              [s.linkActive]:
                !categorySlug &&
                router.pathname !== '/[site]/news/archive/[page]',
            })}
          >
            Latest
          </Link>
          {categories?.map(({ slug, name }) => (
            <Link
              key={slug}
              type="Category"
              href={slug}
              className={classNames(s.link, {
                [s.linkActive]: categorySlug === slug,
              })}
            >
              {name}
            </Link>
          ))}
        </div>
      </div>
    </div>
  )
}

NewsHeader.propTypes = {
  categorySlug: PropTypes.string,
  categories: PropTypes.array,
}

export default NewsHeader
